module.exports = __webpack_public_path__ + "img/Google.3e54afdc.png";